import { defaultValues } from './const'
import { LoginFormVO } from './type'

export const generateDefaultValues = (storeCode: string): LoginFormVO => {
  return {
    ...defaultValues,
    storeCode,
    saveStoreCode: !!storeCode,
  }
}
